<ion-card>
  <ion-card-content>
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size="12">
          <div class="step">
            <ion-skeleton-text
              [animated]="true"
              style="width: 30px; height: 30px"
            ></ion-skeleton-text>
            <div style="width: 100%">
              <ion-skeleton-text
                [animated]="true"
                style="width: 30%; height: 1rem"
              ></ion-skeleton-text>
            </div>
          </div>
        </ion-col>
        <ion-col size="12">
          <div class="step">
            <ion-skeleton-text
              [animated]="true"
              style="width: 30px; height: 30px"
            ></ion-skeleton-text>
            <div style="width: 100%">
              <ion-skeleton-text
                [animated]="true"
                style="width: 30%; height: 1rem"
              ></ion-skeleton-text>
              <ion-skeleton-text
                [animated]="true"
                style="width: 66%; height: 0.75rem"
              ></ion-skeleton-text>
              <ion-skeleton-text
                [animated]="true"
                style="width: 50%; height: 0.75rem"
              ></ion-skeleton-text>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
